import React from "react";
import { useSelector } from "react-redux";
import UserMenu from "./userMenu";
import theme from "../../config/theme";
import { selectGlobalState } from "../../state-management/selectors";

const Header: React.FC = () => {
  const { currentUserData, theme: themeMode } = useSelector(selectGlobalState);
  const mode = themeMode === "light" ? theme.light : theme.dark;
  const isCollapsed = useSelector((state: any) => state.sidebar?.isCollapsed);

  return (
    <div
      className="absolute top-0 left-0 right-0 flex justify-end items-center p-2 bg-gray-100 shadow-md  z-10"
      style={{
        backgroundColor: mode.backgroundColor.bgPrimary,
        color: mode.color.textPrimary,
      }}
    >
      <UserMenu
        username={
          currentUserData
            ? `${currentUserData?.firstname} ${currentUserData?.lastname}`
            : null
        }
        avatarUrl={currentUserData?.picture}
        isCollapsed={isCollapsed}
      />
    </div>
  );
};

export default Header;
